import { inject, Injectable } from '@angular/core';
import { SiteIntervenantControllerApi } from '../../../api/services/site-intervenant-controller-api';
import { firstValueFrom } from 'rxjs';
import { SiteIntervenantDto } from '../../../api/models/site-intervenant-dto';
import { GetSitesP1ByIdIntervenant$Params } from '../../../api/fn/site-intervenant-controller/get-sites-p-1-by-id-intervenant';
import { LoggerWrapper } from '../logger/logger-wrapper.service';

@Injectable({ providedIn: 'root' })
export class SiteIntervenantService {
  private readonly logger = inject(LoggerWrapper);
  constructor(private readonly siteIntervenantApi: SiteIntervenantControllerApi) {}

  getSiteP1Intervenant(id_intervenant: string): Promise<SiteIntervenantDto> {
    try {
      const params: GetSitesP1ByIdIntervenant$Params = {
        idIntervenant: id_intervenant,
      };
      return firstValueFrom(this.siteIntervenantApi.getSitesP1ByIdIntervenant(params));
    } catch (e) {
      this.logger.error(
        e,
        `une erreur est survenue lors de la récupération des dkCodes site P1 pour l'intervenant: ${id_intervenant}`
      );
      return Promise.reject(
        `une erreur est survenue lors de la récupération des dkCodes site P1 pour l'intervenant: ${id_intervenant}`
      );
    }
  }
}
